import { AppAreaConfig } from '@/funnels/@types'
import chairWorkoutsMale from './activity-male-chair-workouts'
import yogaFemale from './activity-female-yoga'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-yoga',
	options: {
		userFlags: ['hasAccessToYogaVideos'],
		userTags: ['yoga'],
	},
	landing: {
		ids: ['loader-yoga', 'age-yoga'],
		route: {
			path: '/yoga',
			name: 'main-yoga-funnel',
		},
		overrides: [
			{
				// Последняя живая ссылка бывших динамических лендингов (lptype/lpid удалены):
				// /yoga?lptype=main_loader&lpid=printable_chair_yoga — маркетинг продолжает лить
				// по ней трафик, поэтому пара параметров матчится как обычные query-параметры
				// ($and обязателен: дефолт матчера без операторов — OR) на статические инстансы
				// с перенесёнными 1-в-1 текстами.
				matcher: {
					$and: {
						lptype: 'main_loader',
						lpid: 'printable_chair_yoga',
					},
				},
				ids: ['loader-printable-chair-yoga', 'age-printable-chair-yoga'],
			},
			{
				matcher: {
					$and: {
						utm_campaign: /search/,
						utm_content: /yoga/,
					},
				},
				ids: ['creatives-search-yoga', 'age-yoga'],
			},
		],
	},
	funnel: {
		id: 'ob-yoga-gender-selection',
		route: {
			path: '/yoga/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'yoga-survey',
		},
		slug: 'main-yoga',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		redirectTo: {
			sex: {
				male: { appArea: chairWorkoutsMale },
				female: { appArea: yogaFemale },
			},
		},
	},
}

export default appAreaConfig
